import { render, staticRenderFns } from "./BusinessStatus.vue?vue&type=template&id=a45562ea"
import script from "./BusinessStatus.vue?vue&type=script&lang=js"
export * from "./BusinessStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a45562ea')) {
      api.createRecord('a45562ea', component.options)
    } else {
      api.reload('a45562ea', component.options)
    }
    module.hot.accept("./BusinessStatus.vue?vue&type=template&id=a45562ea", function () {
      api.rerender('a45562ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/BusinessStatus.vue"
export default component.exports